import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router";

export default function useUrlParamsHandler() {
  const [searchParams, setSearchParams] = useSearchParams();

  const getParams = useCallback((route: string) => {
    return searchParams.get(route) ?? '';
  }, [searchParams]);

  const setParamsToUrl = useCallback((key: string, value: any) => {
    if (value !== 'undefined') {
      if (value) {
        searchParams.set(key, value.toString())
        setSearchParams(searchParams)
      } else {
        searchParams.delete(key)
        setSearchParams(searchParams)
      }
    }
  }, [searchParams, setSearchParams]);

  const setSearchParamsToURL = useCallback((v: URLSearchParams) => {
    setSearchParams(v);
  }, [setSearchParams])

  const urlProps = useMemo(() => {
    return {
      getParams: getParams,
      setParamsToUrl: setParamsToUrl,
      setSearchParamsToUrl: setSearchParamsToURL
    }
  }, [getParams, setSearchParamsToURL, setParamsToUrl])

  return urlProps;
}